// frontend/src/services/games/achievementsService.ts

import { ACHIEVEMENTS, AchievementDefinition, AchievementSessionContext } from '../../config/achievements';
import { GameStats } from './gameStatsService';

const STORAGE_KEY = 'minikcoder:achievements:v1';

type UnlockedMap = Record<string, string>; // achievementId -> ISO unlock tarihi

function readUnlocked(): UnlockedMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeUnlocked(data: UnlockedMap): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // yoksay
  }
}

export function isAchievementUnlocked(id: string): boolean {
  return !!readUnlocked()[id];
}

export function getUnlockedAchievements(gameId?: string): AchievementDefinition[] {
  const unlocked = readUnlocked();
  return ACHIEVEMENTS.filter((a) => unlocked[a.id] && (!gameId || a.gameId === gameId));
}

export function getAchievementsForGame(gameId: string): AchievementDefinition[] {
  return ACHIEVEMENTS.filter((a) => a.gameId === gameId);
}

/**
 * Bir round tamamlandığında çağrılır. Henüz kilidi açılmamış, ilgili oyuna ait
 * başarımları günceli istatistiklere göre kontrol eder ve yeni açılanları döndürür.
 */
export function checkAndUnlockAchievements(
  gameId: string,
  stats: GameStats,
  session: AchievementSessionContext
): AchievementDefinition[] {
  const unlocked = readUnlocked();
  const candidates = ACHIEVEMENTS.filter((a) => a.gameId === gameId && !unlocked[a.id]);
  const newlyUnlocked: AchievementDefinition[] = [];

  for (const achievement of candidates) {
    if (achievement.check(stats, session)) {
      unlocked[achievement.id] = new Date().toISOString();
      newlyUnlocked.push(achievement);
    }
  }

  if (newlyUnlocked.length > 0) writeUnlocked(unlocked);
  return newlyUnlocked;
}
